import { AlertModule } from 'ngx-alerts';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { TranslateModule } from '@ngx-translate/core';
import 'hammerjs';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule, FuseWidgetModule, FuseConfirmDialogModule } from '@fuse/components';
import { NgSelectModule } from '@ng-select/ng-select';
import { fuseConfig } from 'app/fuse-config';

import { FakeDbService } from 'app/fake-db/fake-db.service';
import { AppComponent } from 'app/app.component';
import { AppStoreModule } from 'app/store/store.module';
import { LayoutModule } from 'app/layout/layout.module';
import { LoginComponent } from './main/pages/authentication/login/login.component';
import { MatSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoginGuard } from './guards/login.guard';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { UsersComponent } from './components/users/users.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InformesCalidadComponent } from './components/informes-calidad/informes-calidad.component';
import { DataTablesModule } from 'angular-datatables';
import { IASSSeguimientoComponent } from './components/calidad/iass-seguimiento/iass-seguimiento.component';
import { MaterialModule } from './main/angular-material-elements/material.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { InformacionProcedimientosComponent } from './modals/informacion-procedimientos/informacion-procedimientos.component';
import { HistoriaClinicaComponent } from './modals/historia-clinica/historia-clinica.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { DateFormaterPipe } from './pipes/date-formater.pipe';
import { InformeCalificacionesComponent } from './components/informe-calificaciones/informe-calificaciones.component';
import { BeneficiariosComponent } from './components/apoyo-usuario/beneficiarios/beneficiarios.component';
import { TitularesComponent } from './components/apoyo-usuario/titulares/titulares.component';
import { AuditoriasComponent } from './components/apoyo-usuario/auditorias/auditorias.component';
import { MonitoreoComponent } from './components/apoyo-usuario/monitoreo/monitoreo.component';
import { ServiciosBeneficiarioComponent } from './modals/apoyo-usuario/beneficiarios/servicios-beneficiario/servicios-beneficiario.component';
import { BitacoraComponent } from './modals/apoyo-usuario/beneficiarios/bitacora/bitacora.component';
import { InfoContratoComponent } from './modals/apoyo-usuario/beneficiarios/info-contrato/info-contrato.component';
import { BeneficiarioTelComponent } from './modals/apoyo-usuario/beneficiarios/beneficiario-tel/beneficiario-tel.component';
import { BeneficiarioCelComponent } from './modals/apoyo-usuario/beneficiarios/beneficiario-cel/beneficiario-cel.component';
import { NotasIngresoComponent } from './modals/apoyo-usuario/beneficiarios/opciones/notas-ingreso/notas-ingreso.component';
import { NotasSeguimientoComponent } from './modals/apoyo-usuario/beneficiarios/opciones/notas-seguimiento/notas-seguimiento.component';
import { InformacionComponent } from './modals/apoyo-usuario/beneficiarios/opciones/informacion/informacion.component';
import { ModaltitularesComponent } from './modals/apoyo-usuario/modaltitulares/modaltitulares.component';
import { DespachoComponent } from './components/servicio-medico/despacho/despacho.component';
import { BenefXTitularComponent } from './modals/apoyo-usuario/beneficiarios/info-contrato/benef-x-titular/benef-x-titular.component';
import { PasarApoyoComponent } from './modals/pasar-apoyo/pasar-apoyo.component';
import { PasarRefuerzoComponent } from './modals/pasar-refuerzo/pasar-refuerzo.component';
import { TelPostServicioComponent } from './components/tablas/apoyo-usuario/tel-post-servicio/tel-post-servicio.component';
import { InfoBeneficiarioComponent } from './components/tablas/apoyo-usuario/info-beneficiario/info-beneficiario.component';
import { BitacoraInfoBenefComponent } from './components/tablas/apoyo-usuario/bitacora-info-benef/bitacora-info-benef.component';
import { ProgramarCobrosComponent } from './components/cartera/programar-cobros/programar-cobros.component';
import { LlamadasComponent } from './modals/cartera/llamadas/llamadas.component';
import { FromulariodespachoComponent } from './components/servicio-medico/despacho/subdespacho/fromulariodespacho/fromulariodespacho.component';
import { EquiposComponent } from './components/servicio-medico/despacho/subdespacho/equipos/equipos.component';
import { DatoserviciosComponent } from './components/servicio-medico/despacho/subdespacho/datoservicios/datoservicios.component';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { DebitoGrupoPipe } from './pipes/cartera/debito-grupo.pipe';
import { TipoFacturaComponent } from './modals/cartera/tipo-factura/tipo-factura.component';
import { AppRoutingModule } from './app.routing.module';
import { DespachoModule } from './components/servicio-medico/despacho/despacho.module';
import { TokenInterceptorService } from 'interceptors/token-interceptor.service';
import { DebitoAutoComponent } from './modals/cartera/debito-auto/debito-auto.component';
import { ContratosRegistradosComponent } from './components/contratos/contratos-registrados/contratos-registrados.component';
import { PreContratosComponent } from './components/contratos/pre-contratos/pre-contratos.component';
import { ActividadNotasComponent } from './modals/cartera/actividad-notas/actividad-notas.component';
import { SocketIoModule } from 'ngx-socket-io';
import { socketConf } from 'environments/environment';
import { IassAuditoriaComponent } from './components/calidad/iass-auditoria/iass-auditoria.component';
import { ServiciosIassAuditoriaComponent } from './modals/servicios-iass-auditoria/servicios-iass-auditoria.component';
import { VerCobroComponent } from './modals/cartera/ver-cobro/ver-cobro.component';
import { SolicitarPermisosComponent } from './components/recursos-humanos/solicitar-permisos/solicitar-permisos.component';
import { DireccionServicioComponent } from './modals/direccion-servicio/direccion-servicio.component';
import { ReportePagoComponent } from './modals/cartera/reporte-pago/reporte-pago.component';
import { BitacoraUsuarioComponent } from './modals/bitacora-usuario/bitacora-usuario.component';
import { CscTrasladoComponent } from './modals/csc-traslado/csc-traslado.component';
import { OrdenCscComponent } from './modals/orden-csc/orden-csc.component';
import { VerCobrosCarteraComponent } from './components/cartera/ver-cobros-cartera/ver-cobros-cartera.component';
import { ReprogramarCobroComponent } from './modals/cartera/reprogramar-cobro/reprogramar-cobro.component';
import { BusquedaXNombreComponent } from './modals/cartera/busqueda-x-nombre/busqueda-x-nombre.component';
import { BitacoraGrupoComponent } from './modals/cartera/bitacora-grupo/bitacora-grupo.component';
import { CircularZeroTwentyComponent } from './components/informes-generales/circular-zero-twenty/circular-zero-twenty.component';
import { FormaPagoComponent } from './modals/forma-pago/forma-pago.component';
import { EvaluacionComponent } from './modals/evaluacion/evaluacion.component';
import { LlamadasBitacoraComponent } from './modals/cartera/llamadas-bitacora/llamadas-bitacora.component';
import { HistorialCobrosComponent } from './modals/cartera/historial-cobros/historial-cobros.component';
import { AbonoFacturaComponent } from './modals/cartera/abono-factura/abono-factura.component';
import { BitacoraRetirosComponent } from './modals/cartera/bitacora-retiros/bitacora-retiros.component';
import { FacturasAtrasadasComponent } from './modals/cartera/facturas-atrasadas/facturas-atrasadas.component';
import { HistoricoFacturasComponent } from './modals/cartera/historico-facturas/historico-facturas.component';
import { GestionIngresoUsuariosComponent } from './components/fidelizacion-clientes/gestion-ingreso-usuarios/gestion-ingreso-usuarios.component';
import { InformesServicioClienteComponent } from './components/informes-servicio-cliente/informes-servicio-cliente.component';
import { DireccionComponent } from './modals/direccion/direccion.component';
import { SmsProgramarCobroComponent } from './modals/cartera/sms-programar-cobro/sms-programar-cobro.component';
import { GestionTitularesNuevosComponent } from './components/fidelizacion-clientes/gestion-titulares-nuevos/gestion-titulares-nuevos.component';
import { GestionBeneficiariosNuevosComponent } from './components/fidelizacion-clientes/gestion-beneficiarios-nuevos/gestion-beneficiarios-nuevos.component';
import { BarrioComponent } from './modals/barrio/barrio.component';
import { CobradorXDiaComponent } from './modals/cartera/cobrador-x-dia/cobrador-x-dia.component';
import { AgendaPersonalComponent } from './components/agenda/agenda-personal/agenda-personal.component';
import { ProgramarCobrosFijoComponent } from './components/cartera/programar-cobros-fijo/programar-cobros-fijo.component';
import { EdificioComponent } from './modals/edificio/edificio.component';
import { AgmCoreModule } from '@agm/core';
import { ConsultarUsuarioComponent } from './components/general/consultar-usuario/consultar-usuario.component';
import { ConsultarTitularComponent } from './components/general/consultar-titular/consultar-titular.component';
import { AddCobroFijoComponent } from './modals/cartera/add-cobro-fijo/add-cobro-fijo.component';
import { LlamadaConfirmarPipe } from './pipes/cartera/llamada-confirmar.pipe';
import { NotasDespachoComponent } from './modals/notas-despacho/notas-despacho.component';
import { RegistrarCobroFijoComponent } from './components/cartera/registrar-cobro-fijo/registrar-cobro-fijo.component';
import { TipoAtrasoPipe } from './pipes/cartera/tipo-atraso.pipe';
import { TipoRetiroPipe } from './pipes/cartera/tipo-retiro.pipe';
import { ObservacionCarteraGrupoComponent } from './modals/cartera/observacion-cartera-grupo/observacion-cartera-grupo.component';
import { ConsultarContratoComponent } from './components/general/consultar-contrato/consultar-contrato.component';
import { EstadoCobroPipe } from './pipes/cartera/estado-cobro.pipe';
import { DireccionesComponent } from './components/temporales/direcciones/direcciones.component';
import { BeneficiariosRelacionadosPipe } from './pipes/beneficiarios-relacionados.pipe';
import { GenericSearchPipe } from './pipes/generic-search.pipe';
import { InfoConsecutivoComponent } from './modals/info-consecutivo/info-consecutivo.component';
import { HistorialReprogComponent } from './modals/cartera/historial-reprog/historial-reprog.component';
import { AnalyticsDashboardComponent } from './main/apps/dashboards/analytics/analytics.component';
import { AnalyticsDashboardModule } from './main/apps/dashboards/analytics/analytics.module';
import { AgregarDebitoAutoComponent } from './components/debito-automatico/agregar-debito-auto/agregar-debito-auto.component';
import { RegistrarDebitoAutoComponent } from './components/debito-automatico/registrar-debito-auto/registrar-debito-auto.component';
import { AddDebitoAutoComponent } from './modals/debito-auto/add-debito-auto/add-debito-auto.component';
import { DashboardServicioMedicoComponent } from './components/servicio-medico/dashboard-servicio-medico/dashboard-servicio-medico.component';
import { UsuariosApComponent } from './modals/usuarios-ap/usuarios-ap.component';
import { TotalServiciosGrupoComponent } from './modals/cartera/total-servicios-grupo/total-servicios-grupo.component';
import { UpdateCobradorComponent } from './modals/cartera/update-cobrador/update-cobrador.component';
import { BusquedaGrupoComponent } from './modals/cartera/busqueda-grupo/busqueda-grupo.component';
import { NotasContratosComponent } from './modals/notas-contratos/notas-contratos.component';
import { AgendaCobradorComponent } from './components/cobrador/agenda-cobrador/agenda-cobrador.component';
import { EntregaFacturaComponent } from './components/cobrador/entrega-factura/entrega-factura.component';
import { OrdenCobrosComponent } from './modals/cartera/orden-cobros/orden-cobros.component';
import { UpdateObsCobroComponent } from './modals/cartera/update-obs-cobro/update-obs-cobro.component';
import { BeneficiariosXGrupoComponent } from './modals/cartera/beneficiarios-x-grupo/beneficiarios-x-grupo.component';
import { TesoreriaPrepagoComponent } from './modals/cartera/tesoreria-prepago/tesoreria-prepago.component';
import { CambioEstadoCobroComponent } from './modals/cartera/cambio-estado-cobro/cambio-estado-cobro.component';
import { AddNumeroFacturaComponent } from './modals/cartera/add-numero-factura/add-numero-factura.component';
import { AsociarRadicadoComponent } from './modals/cartera/asociar-radicado/asociar-radicado.component';
import { DashboardCobranzaComponent } from './components/cobranza/dashboard-cobranza/dashboard-cobranza.component';
import { PostServicioComponent } from './components/servicio-al-cliente/post-servicio/post-servicio.component';
import { AuditoriaCarteraComponent } from './components/cartera/informes-cartera/auditoria-cartera/auditoria-cartera.component';
import { LoadCubeComponent } from './components/load-cube/load-cube.component';
import { FinanzasModule } from 'app/finanzas/finanzas.module';
import { CarteraVencidaModule } from './cartera-vencida/cartera-vencida.module';
import { DirectivesModule } from './directives/directives/directives.module';
import { InformesComponent } from './components/servicio-medico/informes/informes.component';
import { GestionarCarteraComponent } from './components/cartera/informes-cartera/gestionar-cartera/gestionar-cartera.component';

registerLocaleData(localeEs);
@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        UsersComponent,
        InformesCalidadComponent,
        IASSSeguimientoComponent,
        InformacionProcedimientosComponent,
        HistoriaClinicaComponent,
        SafeUrlPipe,
        DateFormaterPipe,
        InformeCalificacionesComponent,
        BeneficiariosComponent,
        TitularesComponent,
        AuditoriasComponent,
        MonitoreoComponent,
        ServiciosBeneficiarioComponent,
        BitacoraComponent,
        InfoContratoComponent,
        BeneficiarioTelComponent,
        BeneficiarioCelComponent,
        NotasIngresoComponent,
        NotasSeguimientoComponent,
        InformacionComponent,
        ModaltitularesComponent,
        BenefXTitularComponent,
        PasarApoyoComponent,
        PasarRefuerzoComponent,
        EquiposComponent,
        DatoserviciosComponent,
        FromulariodespachoComponent,
        TelPostServicioComponent,
        InfoBeneficiarioComponent,
        BitacoraInfoBenefComponent,
        ProgramarCobrosComponent,
        LlamadasComponent,
        DebitoGrupoPipe,
        TipoFacturaComponent,
        ContratosRegistradosComponent,
        PreContratosComponent,
        DebitoAutoComponent,
        ActividadNotasComponent,
        IassAuditoriaComponent,
        ServiciosIassAuditoriaComponent,
        VerCobroComponent,
        SolicitarPermisosComponent,
        DireccionServicioComponent,
        ReportePagoComponent,
        BitacoraUsuarioComponent,
        CscTrasladoComponent,
        OrdenCscComponent,
        VerCobrosCarteraComponent,
        ReprogramarCobroComponent,
        BusquedaXNombreComponent,
        BitacoraGrupoComponent,
        CircularZeroTwentyComponent,
        FormaPagoComponent,
        EvaluacionComponent,
        LlamadasBitacoraComponent,
        HistorialCobrosComponent,
        AbonoFacturaComponent,
        BitacoraRetirosComponent,
        FacturasAtrasadasComponent,
        HistoricoFacturasComponent,
        GestionIngresoUsuariosComponent,
        InformesServicioClienteComponent,
        DireccionComponent,
        SmsProgramarCobroComponent,
        BarrioComponent,
        EdificioComponent,
        GestionTitularesNuevosComponent,
        GestionBeneficiariosNuevosComponent,
        BarrioComponent,
        CobradorXDiaComponent,
        ProgramarCobrosFijoComponent,
        ConsultarUsuarioComponent,
        ConsultarTitularComponent,
        AddCobroFijoComponent,
        LlamadaConfirmarPipe,
        NotasDespachoComponent,
        RegistrarCobroFijoComponent,
        TipoAtrasoPipe,
        TipoRetiroPipe,
        ObservacionCarteraGrupoComponent,
        ConsultarContratoComponent,
        EstadoCobroPipe,
        DireccionesComponent,
        BeneficiariosRelacionadosPipe,
        InfoConsecutivoComponent,
        HistorialReprogComponent,
        AgregarDebitoAutoComponent,
        RegistrarDebitoAutoComponent,
        AddDebitoAutoComponent,
        DashboardServicioMedicoComponent,
        UsuariosApComponent,
        TotalServiciosGrupoComponent,
        UpdateCobradorComponent,
        BusquedaGrupoComponent,
        NotasContratosComponent,
        AgendaCobradorComponent,
        EntregaFacturaComponent,
        OrdenCobrosComponent,
        UpdateObsCobroComponent,
        BeneficiariosXGrupoComponent,
        TesoreriaPrepagoComponent,
        CambioEstadoCobroComponent,
        AddNumeroFacturaComponent,
        AsociarRadicadoComponent,
        DashboardCobranzaComponent,
        PostServicioComponent,
        AuditoriaCarteraComponent,
        InformesComponent,
        GestionarCarteraComponent,
    ],
    imports: [
        DirectivesModule,
        AgmCoreModule.forRoot({
            apiKey:'AIzaSyD_uv_S0DYVbz80eKLP0gP0cKLkh8iAcKI',
            libraries:["places"]
        }),
        CarteraVencidaModule,
        DespachoModule,
        FinanzasModule,




        // Final de los modulos

        
        FontAwesomeModule,
        BrowserAnimationsModule,
        AlertModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        NgSelectModule,

        AppRoutingModule,
        RouterModule,

        TranslateModule.forRoot(),
        InMemoryWebApiModule.forRoot(FakeDbService, {
            delay: 0,
            passThruUnknownUrl: true
        }),
        FormsModule,
        ReactiveFormsModule,
        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MaterialModule,
        MatDatepickerModule,
        /* Modulos de datatable */
        DataTablesModule,
        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        FuseWidgetModule,
        FuseConfirmDialogModule,

        // App modules
        LayoutModule,
        AppStoreModule,
        NgxPaginationModule
    ],
    entryComponents: [
        EdificioComponent,
        BarrioComponent,
        DireccionComponent,
        InformacionProcedimientosComponent,
        HistoriaClinicaComponent,
        ServiciosBeneficiarioComponent,
        BitacoraComponent,
        InfoContratoComponent,
        BeneficiarioTelComponent,
        BeneficiarioCelComponent,
        NotasIngresoComponent,
        NotasSeguimientoComponent,
        InformacionComponent,
        BenefXTitularComponent,
        PasarApoyoComponent,
        PasarRefuerzoComponent,
        ModaltitularesComponent,
        LlamadasComponent,
        TipoFacturaComponent,
        DebitoAutoComponent,
        ActividadNotasComponent,
        ServiciosIassAuditoriaComponent,
        VerCobroComponent,
        DireccionServicioComponent,
        ReportePagoComponent,
        BitacoraUsuarioComponent,
        ReprogramarCobroComponent,
        BusquedaXNombreComponent,
        BitacoraGrupoComponent,
        CscTrasladoComponent,
        OrdenCscComponent,
        ReprogramarCobroComponent,
        FormaPagoComponent,
        EvaluacionComponent,
        FormaPagoComponent,
        LlamadasBitacoraComponent,
        HistorialCobrosComponent,
        AbonoFacturaComponent,
        BitacoraRetirosComponent,
        FacturasAtrasadasComponent,
        HistoricoFacturasComponent,
        SmsProgramarCobroComponent,
        CobradorXDiaComponent,
        AddCobroFijoComponent,
        NotasDespachoComponent,
        ObservacionCarteraGrupoComponent,
        InfoConsecutivoComponent,
        HistorialReprogComponent,
        AddDebitoAutoComponent,
        UsuariosApComponent,
        TotalServiciosGrupoComponent,
        UpdateCobradorComponent,
        BusquedaGrupoComponent,
        NotasContratosComponent,
        OrdenCobrosComponent,
        UpdateObsCobroComponent,
        BeneficiariosXGrupoComponent,
        TesoreriaPrepagoComponent,
        CambioEstadoCobroComponent,
        AddNumeroFacturaComponent,
        AsociarRadicadoComponent
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptorService,
            multi: true
        },
        /* {
            provide: LOCALE_ID,
            useValue: "es-ES"
        } */
        Title
    ],
    bootstrap: [
        AppComponent
    ],
    exports:[
        DirectivesModule
    ]
})
export class AppModule {
}
